import type {
  ListVMAgentPackageReviewsReply,
  UpdateVMAgentPackageCompatibilityRequest,
  UpdateVMAgentPackageReviewRequest,
  VMAgentPackageDataSource,
  VMAgentPackageReview,
  VMAgentPackageReviewStatus,
} from '@/types';
import api from './api';
import { vmAgentPackageReviewAPIPath } from './vmAgentPackageReviewDataSource';

export const vmAgentPackageReviewApi = {
  list: async (
    params: {
      agentId?: string;
      status?: VMAgentPackageReviewStatus | 'all';
      limit?: number;
      offset?: number;
    },
    source: VMAgentPackageDataSource = 'tutti-v2',
  ): Promise<ListVMAgentPackageReviewsReply> => {
    const query = {
      ...params,
      status: params.status === 'all' ? undefined : params.status,
    };
    return api.get(vmAgentPackageReviewAPIPath(source), { params: query });
  },

  update: async (
    data: UpdateVMAgentPackageReviewRequest,
    source: VMAgentPackageDataSource = 'tutti-v2',
  ): Promise<VMAgentPackageReview> => {
    return api.post(vmAgentPackageReviewAPIPath(source), data);
  },

  updateCompatibility: async (
    data: UpdateVMAgentPackageCompatibilityRequest,
    source: VMAgentPackageDataSource = 'tutti-v2',
  ): Promise<VMAgentPackageReview> => {
    return api.put(vmAgentPackageReviewAPIPath(source, '/compatibility'), data);
  },
};
